import EntityId from '../domain/EntityId';
import Timepoint from '../time/Timepoint';
import DurationUnit from '../time/DurationUnit';
import Duration from '../time/Duration';

export default class ApiData {

	public constructor (private data: any) {
	}

	public getData (field?: string) {
		return field !== undefined ? this.data[field] : this.data;
	}

	public navigate (field: string) {
		return new ApiData(this.data[field]);
	}

	public isNull (field?: string) {
		return this.getData(field) === null;
	}

	public boolean (field?: string) {
		return Boolean(this.getData(field));
	}

	public booleanOrNull (field?: string) {
		return this.isNull(field) ? null : this.boolean(field);
	}

	public duration (field?: string) {
		const [quantity, unit] = this.string(field).split(' ');

		return unit === DurationUnit.MICROSECOND ? Duration.microseconds(Number(quantity)) : Duration.months(Number(quantity));
	}

	public durationOrNull (field: string) {
		return this.isNull(field) ? null : this.duration(field);
	}

	public id<T> (field?: string) {
		return this.isNull(field) ? new EntityId<T>(null) : new EntityId<T>(this.number(field));
	}

	public number (field?: string) {
		return Number(this.getData(field));
	}

	public numberOrNull (field?: string) {
		return this.isNull(field) ? null : this.number(field);
	}

	public string (field?: string) {
		return String(this.getData(field));
	}

	public stringOrNull (field?: string) {
		return this.isNull(field) ? null : this.string(field);
	}

	public stringOrDefaultIfEmpty (field: string | undefined, defaultString: string) {
		return this.string(field) === '' ? defaultString : this.string(field);
	}

	public stringOrDefaultIfNull (field: string | undefined, defaultString: string) {
		return this.isNull(field) ? defaultString : this.string(field);
	}

	public timepoint (field?: string) {
		return new Timepoint(this.getData(field));
	}

	public timepointOrNull (field?: string) {
		return this.isNull(field) ? null : this.timepoint(field);
	}

	public map (field: string, mapping: (data: ApiData) => any) {
		return (this.data[field] as Array<any>).map(data => mapping(new ApiData(data)));
	}
}


// WEBPACK FOOTER //
// ./code/foundation/repository/ApiData.ts